import { Grid, Typography, Skeleton, Box } from "@mui/material"; // Skeleton for Income by Experience Section
export const IncomeByExperienceSkeleton = () => {
  return (
    <Grid item xs={12}>
      <Box
        sx={{
          p: 3,
          borderRadius: "39px",
          background: "#f5f5f5",
          overflowX: "auto",
          whiteSpace: "nowrap",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontFamily: "poppins",
            fontWeight: 700,
            textAlign: "center",
            mb: 2,
          }}
        >
          <Skeleton width="50%" height={32} sx={{ mx: "auto" }} />
        </Typography>

        <Box sx={{ display: "flex", gap: 2, px: 2 }}>
          {[...Array(7)].map((_, idx) => (
            <Box
              key={idx}
              sx={{
                minWidth: 180,
                p: 2,
                borderRadius: "20px",
                backgroundColor: "#fff",
                boxShadow: 1,
              }}
            >
              <Skeleton width="80%" height={20} />
              <Skeleton width="60%" height={30} sx={{ mt: 1 }} />
              <Skeleton width="100%" height={20} sx={{ mt: 1 }} />
            </Box>
          ))}
        </Box>
      </Box>
    </Grid>
  );
};
